import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';

import { DEFAULT_BANNER } from '../config/constants';

import PageHeader from '../components/PageHeader';
import PostPreview from '../components/PostPreview';

import './styles/posts.scss';

const NavLink = props => {
  if (!props.isTrackable) {
    return <Link to={props.url}>{props.text}</Link>;
  } else {
    return <span>{props.text}</span>;
  }
};

const Posts = ({ data, pathContext, defaultPreview }) => {

  const {
    group,
    index,
    pageCount,
    additionalContext,
  } = pathContext;
  
  const { postsCount } = additionalContext;

  const previousUrl = index - 1 == 1 ? "" : (index - 1).toString();
  const nextUrl = (index + 1).toString();

  const first = (index == 1) ? true : false;
  const last = (index == pageCount) ? true : false;

  return (
    <div className="main postsPage-mainContent">
      <PageHeader
        title="Tous les articles"
        subtitle={`${postsCount} articles`}
      />

      {
        group.map(({ node }) => {
          var { banner } = node.frontmatter;

          const postBanner = (banner)
          ? banner.childImageSharp.sizes
          : defaultPreview.sizes ;

          return (
            <PostPreview 
              key={ node.id }
              data={ node }
              image={ postBanner }
              className="postPreview--fullWidth"
            />
          );
        })
      }

      <div className="posts-paginate-links">
        {
          !first &&
            <div className="posts-paginate-links-previous">
              <NavLink isTrackable={first} url={`/posts/${previousUrl}`} text="< Précédents" />
            </div>
        }
        {
          !last &&
            <div className="posts-paginate-links-next">
              <NavLink isTrackable={last} url={`/posts/${nextUrl}`} text="Suivants >" />
            </div>
        }
      </div>
    </div>
  );
};

Posts.propTypes = {
  data: PropTypes.object,
}

export default Posts;



// WEBPACK FOOTER //
// ./src/templates/posts.jsx